import { post } from 'utils/sdk';

interface IInitiateFlightTicketsPaymentParams {
  flightTicketProposalUUID: string;
  selectedPaymentMethod: string;
  currency: string;
}

export const initiateFlightTicketsPayment = ({
  flightTicketProposalUUID,
  selectedPaymentMethod,
  currency,
}: IInitiateFlightTicketsPaymentParams) =>
  post<{ checkout_url?: string }>('api/customer-facing/initiate-payment', {
    flight_ticket_proposal_uuid: flightTicketProposalUUID,
    payment_method: selectedPaymentMethod,
    selected_currency: currency,
  });
